<template>
    <BaseSelect
      v-model="modelValue"
      v-bind="$attrs"
      :options="options && options.length ? options : CASH_CALL_CLAIM_COUNTRY_OPTIONS"
      size="sm"
      label="Claim Country"
      rules="required"
    >
      <template v-slot:label>Claim Country <span class="text-danger">*</span> </template>
  
      <template v-slot:first>
        <b-form-select-option :value="undefined"
          >Select</b-form-select-option
        >
      </template>
    </BaseSelect>
  </template>
  
  <script>
  import { defineComponent, computed } from '@vue/composition-api'  
  import { CASH_CALL_CLAIM_COUNTRY_OPTIONS } from '@constants'  
  import { BaseSelect } from '@components/base'
  
  export default defineComponent({
    name: 'CashCallFormCountry',
    components: {
      BaseSelect
    },
    props: {
      value: String,
      // Optional override for the country list. When omitted, the default
      // USA/UK/Canada list is used (normal cash call). The co-lead flow passes
      // the full world list.
      options: {
        type: Array,
        default: null
      }
    },
    emits: ['input'],
    setup(props, { emit }) {   
  
      const displayflex = "displayflex"

      const modelValue = computed({
        get: () => props.value,
        set: (newValue) => emit('input', newValue)
      })   
  
      return {
        CASH_CALL_CLAIM_COUNTRY_OPTIONS,  
        modelValue
      }
    }
  })
  </script>
  